module.exports = __webpack_public_path__ + "assets/7ee0536ee00732edd3b7f1af4584f954.png";